// ANCHOR React
import { ChangeEvent, KeyboardEvent } from 'react';

// ANCHOR Models
import { useUpdateFormQuestionPositionFormPosition } from '@lyon/scoped-models/form/update/UpdateFormQuestionPositionForm';

// ANCHOR Hooks
import { useConstantCallback } from '@lyon/utils/hooks/useConstantCallback';

// ANCHOR Utils
import { numberOnlyInput } from '@lyon/utils/extras/numberOnlyInput';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { FormField } from '@lyon/components/utils/FormField';

// ANCHOR Constants
import { PLACEHOLDER, LABEL, START_ENHANCER } from './constants';

// ANCHOR Styles
import { FORM_CONTROL } from './styles';

export const LyonUpdateFormPositionInput = constant(() => {
  const [
    position, setPosition, originalValue,
  ] = useUpdateFormQuestionPositionFormPosition();

  const onChange = useConstantCallback((event: ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.currentTarget.value);

    if (!Number.isNaN(value)) {
      setPosition(value);
    } else {
      setPosition(undefined);
    }
  });

  const onKeyPress = useConstantCallback((event: KeyboardEvent<HTMLInputElement>) => {
    numberOnlyInput(event);
  });

  return (
    <FormField
      type="number"
      value={position ?? ''}
      onChange={onChange}
      label={LABEL}
      placeholder={PLACEHOLDER}
      formOverrides={FORM_CONTROL}
      onKeyPress={onKeyPress}
      startEnhancer={START_ENHANCER}
      required
      caption={`Original Number: ${originalValue ?? 'N/A'}`}
    />
  );
});
